import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { renderRichTextReact } from '../../../utils/storyblokRichText';
import type { CartMessage as CartMessageBlok } from '../../../../.storyblok/types/255103/storyblok-components';

const CartMessage: React.FC<{ blok: CartMessageBlok }> = ({ blok }) => {
  if (!blok.visible) return null;

  return (
    <div
      className={`bg-cerulean-100 px-[12px] py-[8px] mt-6 md:mt-0 mb-[100px] typography-body-xxs !text-navy-600
        [&_a]:!text-navy-600 [&_a]:font-bold [&_a]:underline`}
      {...storyblokEditable(blok)}
    >
      {renderRichTextReact(blok.body)}
    </div>
  );
};

export default CartMessage;
